/**
 * @file: description
 * @author:
 * @Date: 2020-03-24 13:27:34
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-03-24 14:30:54
 */
const loader = (name: string) => async () => {
  const entrance = await import(/* webpackChunkName: "f.thematic" */ './');
  return entrance[name];
};

import { IRoute } from 'src/types';

export const childRoutes: IRoute[] = [
  {
    load: loader('HomePage'),
    path: 'home-page/:topicId'
  }
];
export default {
  path: 'thematic',
  name: 'thematic',
  childRoutes
};
